module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra-padding-bottom"
  }, [_c('h2', [_vm._v("Atoms")]), _vm._v(" "), _c('h2', [_vm._v("Solid Border")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Hatch Background")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(1), _vm._v(" "), _c('span-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Gradient Background")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Crosshair Background")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(3), _vm._v(" "), _c('crosshair-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Combined Hatch/Crosshair")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(4), _vm._v(" "), _c('crosshair-background'), _vm._v(" "), _c('span-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Image")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('image-component', {
    attrs: {
      "image": _vm.example_image
    }
  })], 1)])]), _vm._v(" "), _c('h2', [_vm._v("Video")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('video-component', {
    attrs: {
      "video": _vm.example_video
    }
  })], 1)])]), _vm._v(" "), _c('h2', [_vm._v("Static SVGs/SVG Icons")]), _vm._v(" "), _c('div', [_c(_vm.current_svg, {
    tag: "component"
  })], 1), _vm._v(" "), _c('h3', [_vm._v("select from dropdown")]), _vm._v(" "), _c('select', {
    attrs: {
      "svg-select": ""
    },
    on: {
      "change": _vm.change_svg
    }
  }, _vm._l((_vm.svg_list), function(component) {
    return _c('option', {
      key: component
    }, [_vm._v(_vm._s(component))])
  })), _vm._v(" "), _c('h2', [_vm._v("Radio Buttons")]), _vm._v(" "), _c('radio'), _vm._v(" "), _c('radio', {
    attrs: {
      "type": "incorrect"
    }
  }), _vm._v(" "), _c('radio', {
    attrs: {
      "type": "correct"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Arrows")]), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "next"
    }
  }), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "prev"
    }
  }), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative border-blue"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md bg-gradient ratio-4-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 debug"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-example ind-top"
  }, [_c('h3', [_vm._v("navbar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1932faac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/style_guide/atoms.vue
// module id = 598
// module chunks = 1